/* eslint-disable */
import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { StatusBar } from '@capacitor/status-bar';
import { AlertController, CheckboxCustomEvent, IonModal, MenuController, Platform, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SiteService } from './services/site.service';
import { UserService } from './services/user.service';
/* es-lint-enable */

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public appPages = [];
  public site: any = { properties: {} };
  public user: any = { rights: {} };
  public isLogged = false;
  public subUser: Subscription;
  public subSite: Subscription;
  public onLangChange: Subscription;
  private networkStatus = true;
  private privacyPolicy: boolean;
  canDismiss = false;
  presentingElement = null;
  @ViewChild(IonModal) privacyModal: IonModal;

  constructor(
    private platform: Platform,
    private authenticationService: AuthenticationService,
    private el: ElementRef,
    public translate: TranslateService,
    public activatedRoute: ActivatedRoute,
    public storage: Storage,
    public siteService: SiteService,
    public userService: UserService,
    public menu: MenuController,
    private alertController: AlertController,
    // private deeplinks: Deeplinks,
    private router: Router,
    private zone: NgZone,
    public toast: ToastController,
  ) {


  }

  async ngOnInit() {
    await this.storage.create();
    this.menu.enable(false);
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#ff8a2e' })
    }
    this.authenticationService.checkToken();
    this.translate.addLangs(['en', 'fr']);
    this.translate.setFallbackLang('fr');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|fr/) ? browserLang : 'fr');
    this.updateLanguage();
    this.onLangChange = this.translate.onLangChange.subscribe(() => {
      this.updateLanguage();
    });

    this.authenticationService.isLoggedIn.subscribe((logged) => {
      if (logged === true) {
        this.isLogged = logged;
        this.storage.get('userInfos').then((user) => {
          if (user && user.id) {
            this.user = user;
            let lang = 'fr';
            if (user.lang) {
              lang = user.lang;
            } else if (user.properties && user.properties.lang) {
              lang = user.properties.lang;
            }
            this.translate.use(lang);
          }
        });
      } else if (this.isLogged) {
        this.isLogged = false;
      }
    });
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      // console.log('platforms: ', this.platform.platforms());
      // console.log('platform->mobileweb: ', this.platform.is('mobileweb'));
      this.initNetwork();
      this.presentingElement = document.querySelector('.ion-page');
      this.privacyPolicy = await this.storage.get('privacyPolicy');
      if (!this.privacyPolicy && this.platform.is('mobile')) {
        this.privacyModal.present();
      }
      if (this.platform.is('mobileweb')) {
        this.activatedRoute.queryParams.subscribe((qp) => {
          // console.log('queryParams: ', qp)
          if (qp.platform === 'mobile') {
            this.router.navigate(['store-links']);
          }
        });
      }
      this.initAppPage();
      this.setupDeeplinks();
    });
  }

  public async initAppPage() {
    this.subSite = this.siteService.getSite().subscribe((site) => {
      if (site && site.properties) {
        this.site = site;
        site.properties.collaborators.forEach((collab) => {
          if (collab.userId === this.user.id) {
            this.user.rights = collab.rights;
            this.user.role = collab.role;
            this.user.devices = collab.devices;
            this.user.deviceGroups = collab.deviceGroups;
          }
        });
      }

    });
  }

  public setupDeeplinks() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      console.log('appUrlOpen->event', event);
      this.zone.run(() => {
        const domain = 'manager.solupass.fr';

        const pathArray = event.url.split(domain);
        // The pathArray is now like ['https://manager.solupass.fr', '/details/42']

        // Get the last element with pop()
        const appPath = pathArray.pop();
        if (appPath) {
          this.router.navigateByUrl(appPath);
        }
      });
    });
  }

  private initNetwork() {
    let timeoutId: any;
    Network.addListener('networkStatusChange', status => {
      if (this.networkStatus !== status.connected) {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(async () => {
          const currentStatus = await Network.getStatus();
          if (currentStatus.connected === status.connected) {
            this.networkStatus = status.connected;
            console.log('Network status:', status);
            if (status.connected) {
              // display connexion ok
              this.toast.create({
                message: 'Connexion internet restaurée.',
                duration: 3000,
                icon: 'wifi-outline',
                position: 'bottom'
              }).then((toastData) => {
                toastData.present();
              });
            } else {
              // display connexion ko
              this.toast.create({
                message: 'Vous êtes hors ligne.',
                duration: 3000,
                icon: 'cloud-offline-outline',
                position: 'bottom'
              }).then((toastData) => {
                toastData.present();
              });
            }
          }
        }, 10000);
      }
    });
  }




  onTermsChanged(event: Event) {
    const ev = event as CheckboxCustomEvent;
    this.canDismiss = ev.detail.checked;
    this.storage.set('privacyPolicy', this.canDismiss);
  }

  public logout() {
    this.isLogged = false;
    this.authenticationService.logout();
  }

  /**
   * Update the language in the lang attribute of the html element.
   */
  private updateLanguage(): void {
    const lang = document.createAttribute('lang');
    lang.value = this.translate.getCurrentLang();
    this.el.nativeElement.parentElement.parentElement.attributes.setNamedItem(lang);
  }

  ngOnDestroy(): void {
    this.subUser.unsubscribe();
    this.subSite.unsubscribe();
    this.onLangChange.unsubscribe();
  }
}
